/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/home.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Home',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.15998 2.58795C8.06516 2.51684 7.93479 2.51684 7.83998 2.58795L2.50664 6.58795C2.43949 6.63831 2.39998 6.71735 2.39998 6.80129V13.3013C2.39998 13.4486 2.51937 13.568 2.66664 13.568H5.66664C5.81392 13.568 5.93331 13.4486 5.93331 13.3013V9.96795C5.93331 8.82656 6.85859 7.90129 7.99998 7.90129C9.14136 7.90129 10.0666 8.82656 10.0666 9.96795V13.3013C10.0666 13.4486 10.186 13.568 10.3333 13.568H13.3333C13.4806 13.568 13.6 13.4486 13.6 13.3013V6.80129C13.6 6.71735 13.5605 6.63831 13.4933 6.58795L8.15998 2.58795ZM7.35998 1.94795C7.73923 1.66351 8.26072 1.66351 8.63998 1.94795L13.9733 5.94795C14.2419 6.1494 14.4 6.46554 14.4 6.80129V13.3013C14.4 13.8904 13.9224 14.368 13.3333 14.368H10.3333C9.7442 14.368 9.26664 13.8904 9.26664 13.3013V9.96795C9.26664 9.26839 8.69954 8.70129 7.99998 8.70129C7.30042 8.70129 6.73331 9.26839 6.73331 9.96795V13.3013C6.73331 13.8904 6.25575 14.368 5.66664 14.368H2.66664C2.07754 14.368 1.59998 13.8904 1.59998 13.3013V6.80129C1.59998 6.46554 1.75805 6.1494 2.02664 5.94795L7.35998 1.94795Z"
            fill="currentColor"
          />
        </>
      )
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.24 3.85629C12.0978 3.74963 11.9022 3.74963 11.76 3.85629L3.76002 9.85629C3.6593 9.93184 3.60002 10.0504 3.60002 10.1763V19.9263C3.60002 20.1472 3.77911 20.3263 4.00002 20.3263H8.50002C8.72094 20.3263 8.90002 20.1472 8.90002 19.9263V14.9263C8.90002 13.2142 10.2879 11.8263 12 11.8263C13.7121 11.8263 15.1 13.2142 15.1 14.9263V19.9263C15.1 20.1472 15.2791 20.3263 15.5 20.3263H20C20.2209 20.3263 20.4 20.1472 20.4 19.9263V10.1763C20.4 10.0504 20.3407 9.93184 20.24 9.85629L12.24 3.85629ZM11.04 2.89629C11.6089 2.46963 12.3911 2.46963 12.96 2.89629L20.96 8.89629C21.3629 9.19846 21.6 9.67268 21.6 10.1763V19.9263C21.6 20.8099 20.8837 21.5263 20 21.5263H15.5C14.6164 21.5263 13.9 20.8099 13.9 19.9263V14.9263C13.9 13.877 13.0494 13.0263 12 13.0263C10.9507 13.0263 10.1 13.877 10.1 14.9263V19.9263C10.1 20.8099 9.38368 21.5263 8.50002 21.5263H4.00002C3.11637 21.5263 2.40002 20.8099 2.40002 19.9263V10.1763C2.40002 9.67268 2.63714 9.19846 3.04002 8.89629L11.04 2.89629Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
